import request from '@/utils/request'

export function resetEmail(data) {
  return request({
    url: 'api/code/resetEmail?email=' + data,
    method: 'post'
  })
}

export function updatePass(data) {
  return request({
    url: '/api/v1/users/updatePass',
    method: 'POST',
    data
  })
}
